module.exports = __webpack_public_path__ + "img/23.047933b2.png";